import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CookieModule } from 'ngx-cookie';

import { FooterSharedComponent } from './footer.component';
import { MegaFooterSharedComponent } from './mega.footer/mega.footer.component';

import { FaIconSharedModule } from '../../atoms/fa.icon/fa.icon.module';
import { FooterNavSharedModule } from './../../molecules/footer.nav/footer.nav.module';
import { NewsletterSharedModule } from './../../molecules/newsletter/newsletter.module';
import { FooterAddressSharedModule } from './../../molecules/footer.address/footer.address.module';

@NgModule({
    declarations: [
        FooterSharedComponent,
        MegaFooterSharedComponent
    ],
    imports: [
        CommonModule,
        FaIconSharedModule,
        FooterNavSharedModule,
        CookieModule.forRoot(),
        NewsletterSharedModule,
        FooterAddressSharedModule
    ],
    exports: [
        FooterSharedComponent,
        MegaFooterSharedComponent
    ]
})

export class FooterSharedModule {}
